import * as React from 'react';
import { Link } from 'react-router-dom';
import * as _ from 'lodash';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import { fetchMenus } from '../actions/posts';
import { getCookie } from '../helpers/index';

class HomeFooterMenus extends React.Component<any, any> {

	constructor(props) {
		super(props);
	}

	componentDidMount(): void {
		this.props.fetchMenus({
			post_type: 'menu',
			number: 500
		});
	}

	render() {

		const { menusWP, t } = this.props;
		var language = 'vn';

		if(getCookie('language_landing')) {
			language = getCookie('language_landing');
		}
		let allFooter1Html = [], allFooter1 = [];
		let allFooter2Html = [], allFooter2 = [];
		let allFooter3Html = [], allFooter3 = [];
		let allFooter4Html = [], allFooter4 = [];
		let filteredMenus = _.filter(menusWP.data, function (post) {
			return _.some(post.custom_fields, { 'key': 'language', 'value': language });
		});
		filteredMenus.sort(function (a, b) {
			return a.post_id - b.post_id;
		}).map((menuItems) => {
			let customFields = menuItems.custom_fields;
			let link = '#';
			let position = '';
			let title = menuItems.post_title;
			let type = menuItems.post_excerpt;
			let post_parent = menuItems.post_parent;

			customFields.map((cField) => {
				if (cField.key === 'link') {
					link = cField.value;
				}

				if (cField.key === 'position') {
					position = cField.value;
				}
			});
			if (position === 'footer1') {
				allFooter1.push({
					title: title,
					link: link,
					type: type,
					position: position,
					post_parent: post_parent
				});
			}
			else if (position === 'footer2') {
				allFooter2.push({
					title: title,
					link: link,
					type: type,
					position: position,
					post_parent: post_parent
				});
			} else if (position === 'footer3') {
				allFooter3.push({
					title: title,
					link: link,
					type: type,
					position: position,
					post_parent: post_parent
				});
			} else if (position === 'footer4') {
				allFooter4.push({
					title: title,
					link: link,
					type: type,
					position: position,
					post_parent: post_parent
				});
			}

			//sort all menus
			allFooter1.sort(function (a, b) {
				return a.post_parent - b.post_parent;
			});

			allFooter2.sort(function (a, b) {
				return a.post_parent - b.post_parent;
			});

			allFooter3.sort(function (a, b) {
				return a.post_parent - b.post_parent;
			});

			allFooter4.sort(function (a, b) {
				return a.post_parent - b.post_parent;
			});
		});

		allFooter1Html = allFooter1.map((item) => {
			if (item.type == 0) {
				var pathname = new URL(item.link).pathname;
				return (<li key={item.link + item.title}><Link to={pathname}>{item.title}</Link></li>);
			}
			return (<li key={item.link + item.title}><a href={item.link} target='_blank'>{item.title}</a></li>);
		});

		allFooter2Html = allFooter2.map((item) => {
			if (item.type == 0) {
				var pathname = new URL(item.link).pathname;
				return (<li key={item.link + item.title}><Link to={pathname}>{item.title}</Link></li>);
			}
			return (<li key={item.link + item.title}><a href={item.link} target='_blank'>{item.title}</a></li>);
		});

		allFooter3Html = allFooter3.map((item) => {
			if (item.type == 0) {
				var pathname = new URL(item.link).pathname;
				return (<li key={item.link + item.title}><Link to={pathname}>{item.title}</Link></li>);
			}
			return (<li key={item.link + item.title}><a href={item.link} target='_blank'>{item.title}</a></li>);
		});

		allFooter4Html = allFooter4.map((item) => {
			if (item.type == 0) {
				var pathname = new URL(item.link).pathname;
				return (<li key={item.link + item.title}><Link to={pathname}>{item.title}</Link></li>);
			}
			return (<li key={item.link + item.title}><a href={item.link} target='_blank'>{item.title}</a></li>);
		});


		return (
			<footer>
				<div className="row mb-3">
					<div className="col-6 col-sm-3">
						<div className="column">
							<h6>{t('news')}</h6>
							<ul className="list-footer">
								{allFooter1Html}
							</ul>
						</div>
					</div>
					<div className="col-6 col-sm-3">
						<div className="column">
							<h6>{t('stores')}</h6>
							<ul className="list-footer">
								{allFooter2Html}
							</ul>
						</div>
					</div>
					<div className="col-6 col-sm-3">
						<div className="column">
							<h6>{t('drink')}</h6>
							<ul className="list-footer">
								{allFooter3Html}
							</ul>
						</div>
					</div>
					<div className="col-6 col-sm-3">
						<div className="column">
							<h6>{t('link')}</h6>
							<ul className="list-footer">
								{allFooter4Html}
							</ul>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}
export default connect(mapStateToProps([
	'menusWP'
]), mapDispatchToProps({
	fetchMenus
}))(translate('translations')(HomeFooterMenus));



// WEBPACK FOOTER //
// ./src/components/HomeFooterMenus.tsx